var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvancedDeathAuditNew = function SvgAdvancedDeathAuditNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.667 52h-44v-2.667h44zM52 46.667H14.667V44H52zM44 22.667H21.333V20H44zM44 28H21.333v-2.667H44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.314 6.525a17.5 17.5 0 0 1 6.353-1.192c2.178 0 4.336.405 6.352 1.192a16.8 16.8 0 0 1 5.404 3.404 15.8 15.8 0 0 1 3.63 5.122 15.1 15.1 0 0 1 1.28 6.067h-2.666a12.4 12.4 0 0 0-1.055-4.994 13.1 13.1 0 0 0-3.018-4.254 14.1 14.1 0 0 0-4.544-2.861A14.8 14.8 0 0 0 32.667 8c-1.85 0-3.679.343-5.383 1.009a14.1 14.1 0 0 0-4.545 2.86 13.1 13.1 0 0 0-3.018 4.255 12.4 12.4 0 0 0-1.054 4.994H16c0-2.084.436-4.146 1.28-6.067a15.8 15.8 0 0 1 3.63-5.122 16.8 16.8 0 0 1 5.404-3.404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 44H16V21.118h2.667zm30.666 0h-2.666V21.118h2.666zM13.333 49.333V44H16v5.333zM52 56v-5.333h2.667V56zM10.667 56v-5.333h2.666V56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.667 57.333h-44v-2.666h44zM49.333 50.667v-5.334H52v5.334z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export { SvgAdvancedDeathAuditNew as Icon };
export default __webpack_public_path__ + "static/media/99a844d5723a0140d9d33d88702da1bf.svg";